import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bell, BellOff, BellRing } from "lucide-react";
import { Button } from "./ui/button";
import { pushSupported, getPushPermission, enablePush, disablePush } from "../lib/push";

// audience: "employee" | "user"
export const PushToggle = ({ audience, className = "", compact = false }) => {
  const [supported, setSupported] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setSupported(pushSupported());
    (async () => {
      if (!pushSupported()) return;
      try {
        const reg = await navigator.serviceWorker.getRegistration();
        const sub = reg ? await reg.pushManager.getSubscription() : null;
        setEnabled(getPushPermission() === "granted" && !!sub);
      } catch { /* ignore */ }
    })();
  }, []);

  if (!supported) return null;

  const toggle = async () => {
    setBusy(true);
    try {
      if (enabled) {
        await disablePush();
        setEnabled(false);
        toast.success("تم إيقاف إشعارات الجهاز");
      } else {
        await enablePush(audience);
        setEnabled(true);
        toast.success("تم تفعيل الإشعارات الفورية ✓");
      }
    } catch (e) {
      if (e?.message === "denied") toast.error("تم رفض إذن الإشعارات من المتصفح. فعّله من إعدادات الموقع.");
      else toast.error("تعذّر تفعيل الإشعارات على هذا الجهاز");
    } finally { setBusy(false); }
  };

  const Icon = enabled ? BellRing : BellOff;
  return (
    <Button
      type="button" variant={enabled ? "default" : "outline"} size="sm"
      onClick={toggle} disabled={busy} data-testid="push-toggle"
      className={`gap-1.5 ${enabled ? "bg-blue-600 hover:bg-blue-700 text-white" : ""} ${className}`}>
      <Icon className="h-4 w-4" />
      {!compact && <span className="text-xs">{enabled ? "الإشعارات مُفعّلة" : "فعّل الإشعارات"}</span>}
    </Button>
  );
};
